module.exports = __webpack_public_path__ + "static/img/loginBg.3fb3e37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginBg.jpg
// module id = qUwY
// module chunks = 3